var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x8F\xE1\x85\xA6\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x87\xE1\x85\xA2\xE1\x86\xBC\xE1\x84\x8F\xE1\x85\xB3 1",
    clipPath: "url(#clip0_1736_10109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#140064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.51721 9.92383H6.50543L4.90788 11.7838V9.92383H4.1001V13.9818H4.90788V12.1169L6.55832 13.9818H7.5701L5.77432 11.9529L7.51721 9.92383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.9 13.9818L19.6865 12.5783L20.8636 11.1747H19.9927L18.9665 12.3892V9.92383H18.1587V13.9818H18.9665V12.7641L20.012 13.9818H20.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.50519 11.0758C9.16586 11.0758 8.87586 11.2198 8.63741 11.4229V9.92383H7.83008V12.5965C7.83008 13.4009 8.3623 14.0745 9.36341 14.0745C10.2639 14.0745 10.8994 13.4523 10.8994 12.5812C10.8972 11.7558 10.3523 11.0758 9.50519 11.0758ZM9.36119 13.3425C9.16118 13.3426 8.96904 13.2646 8.82561 13.1252C8.68219 12.9858 8.5988 12.796 8.59319 12.5961V12.5738C8.59319 12.4219 8.63823 12.2734 8.72262 12.1472C8.80701 12.0209 8.92695 11.9224 9.06729 11.8643C9.20762 11.8062 9.36204 11.791 9.51102 11.8206C9.66 11.8502 9.79684 11.9234 9.90425 12.0308C10.0117 12.1382 10.0848 12.275 10.1144 12.424C10.1441 12.573 10.1289 12.7274 10.0707 12.8677C10.0126 13.0081 9.91416 13.128 9.78787 13.2124C9.66157 13.2968 9.51309 13.3418 9.36119 13.3418V13.3425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.6068 11.0763C16.2623 11.0721 15.9291 11.1992 15.675 11.4318V11.1652H14.8677V13.9836H15.675V12.4032C15.6802 12.2487 15.7452 12.1023 15.8563 11.9948C15.9674 11.8874 16.1159 11.8273 16.2705 11.8273C16.425 11.8273 16.5735 11.8874 16.6846 11.9948C16.7957 12.1023 16.8607 12.2487 16.8659 12.4032V13.9836H17.679V12.1449C17.677 11.8615 17.5633 11.5903 17.3626 11.3902C17.1618 11.1901 16.8902 11.0773 16.6068 11.0763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.8302 11.0781C11.9191 11.0781 11.2798 11.7021 11.2798 12.5715C11.2798 13.3961 11.8309 14.0768 12.6871 14.0768C12.874 14.0739 13.0578 14.0289 13.2249 13.9451C13.3919 13.8613 13.5379 13.7408 13.652 13.5928V13.983H14.3825V12.5719H14.3758L14.3825 12.5561C14.3811 11.7517 13.844 11.0781 12.8302 11.0781ZM12.8476 13.339C12.6957 13.339 12.5472 13.294 12.4209 13.2096C12.2946 13.1252 12.1962 13.0052 12.138 12.8649C12.0799 12.7246 12.0647 12.5702 12.0943 12.4212C12.124 12.2722 12.1971 12.1354 12.3045 12.028C12.4119 11.9205 12.5488 11.8474 12.6977 11.8178C12.8467 11.7881 13.0011 11.8033 13.1415 11.8615C13.2818 11.9196 13.4017 12.018 13.4861 12.1443C13.5705 12.2706 13.6156 12.4191 13.6156 12.571C13.6156 12.7747 13.5346 12.97 13.3906 13.1141C13.2466 13.2581 13.0512 13.339 12.8476 13.339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_10109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbank);
export default __webpack_public_path__ + "static/media/kbank.d7eb480b679e1236cba6f7658162e155.svg";
export { ForwardRef as ReactComponent };